import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';

export default function Imprensa() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    return (
        <div className="page"><Header />
            <main style={{ flex:1,padding:'40px 20px' }}>
                <div style={{ maxWidth:800,margin:'0 auto',textAlign:'center' }}>
                    <h2 className="section-title color_5">{t.press_title}</h2>
                    <p className="text mb-40">{t.press_subtitle}</p>
                    <div style={{ display:'flex',gap:20,justifyContent:'center',flexWrap:'wrap' }}>
                        <a href="/release_br.pdf" target="_blank" className="btn-send btn-modern">
                            {language==='en'?'Press Release (PT)':'Press Release (PT)'}
                        </a>
                        <a href="/release_en.pdf" target="_blank" className="btn-send btn-modern">
                            {language==='en'?'Press Release (EN)':'Press Release (EN)'}
                        </a>
                    </div>
                    <div className="mt-40">
                        <Link to="/noticias" className="btn-send" style={{ backgroundColor:'var(--color-beige)',color:'var(--color-dark)' }}>
                            {language==='en'?'View articles':'Ver matérias'}
                        </Link>
                    </div>
                </div>
            </main>
        <Footer /></div>
    );
}
